export const titleTextFeatures = 'С нами ты сможешь'
export const arrCards = [
  {
    cardImg: 'card1_featuresSection',
    title: 'Пополнить словарный запас',
    description: 'Более 3500 слов',
  },
  {
    cardImg: 'card2_featuresSection',
    title: 'Сохранять сложное на потом',
    description: 'Раздел для сложных слов',
  },
  {
    cardImg: 'card3_featuresSection',
    title: 'Учиться играючи',
    description: 'Две увлекательные игры',
  },
  {
    cardImg: 'card4_featuresSection',
    title: 'Анализировать свой прогресс',
    description: 'Подробная статистика успеха',
  },
]
